import { toast } from 'react-toastify';
export const displayPdfDownloadToast = (success, t) => {
    if (success) {
        toast.success(t('email-dialog.success-dialog'));
    }
    else {
        toast.error(t('email-dialog.failure-dialog'));
    }
};
